import React, { useState } from 'react';
import { computeFeeTotals, formatPercent } from './feeUtils';

const FeeCopyFromModal = ({ targetRow, rows, multiplier, onSelect, onClose }) => {
  const [search, setSearch] = useState('');

  const q = search.trim().toLowerCase();
  const candidates = rows
    .filter(r => r.portfolio_code !== targetRow.portfolio_code)
    .filter(r => !q || [r.portfolio_code, r.portfolio_name, r.platform, r.series, r.blender_code]
      .some(v => (v || '').toLowerCase().includes(q)));

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#072040', color: '#fff' }}>
            <h6 className="modal-title">
              Copy fees into {targetRow.portfolio_code}
              {targetRow.platform && <span className="fw-normal"> ({targetRow.platform})</span>}
            </h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <input
              type="text"
              className="form-control form-control-sm mb-3"
              placeholder="Search by code, name, platform or series..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />
            <div className="table-responsive">
              <table className="table table-sm table-hover align-middle" style={{ fontSize: '0.85rem' }}>
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Platform</th>
                    <th>Series</th>
                    <th className="text-end">Total Fixed</th>
                    <th className="text-end">Total Variable</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {candidates.map(r => {
                    const totals = computeFeeTotals(r, multiplier);
                    return (
                      <tr key={r.portfolio_code} style={{ cursor: 'pointer' }} onClick={() => onSelect(r)}>
                        <td className="fw-semibold">
                          {r.in_registry && (
                            <span style={{ color: '#f0a500' }} className="me-1" title="Portfolio Registry entry">★</span>
                          )}
                          {r.portfolio_code}
                        </td>
                        <td>
                          <span className="d-inline-block text-truncate" style={{ maxWidth: '200px' }} title={r.portfolio_name || ''}>
                            {r.portfolio_name || '-'}
                          </span>
                        </td>
                        <td>{r.platform || '-'}</td>
                        <td>{r.series}</td>
                        <td className="text-end">{totals.total_fixed_cost != null ? formatPercent(totals.total_fixed_cost) : '-'}</td>
                        <td className="text-end">{totals.total_variable_cost != null ? formatPercent(totals.total_variable_cost) : '-'}</td>
                        <td className="text-end">
                          <button className="btn btn-sm btn-outline-primary" onClick={(e) => { e.stopPropagation(); onSelect(r); }}>
                            Copy
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  {candidates.length === 0 && (
                    <tr><td colSpan={7} className="text-muted text-center py-3">No matching portfolios</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer py-2">
            <small className="text-muted me-auto">
              Copies PDS date and fee values into the row — review then Save All to persist.
            </small>
            <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeCopyFromModal;
